export default function Footer() {
  return (
    <footer className="mt-16 md:mt-20 pt-6 md:pt-8 border-t border-border-dark text-muted-dark flex justify-between gap-6 md:gap-3.5 flex-wrap text-sm leading-[1.6]" aria-label="Footer">
      <div>
        <div className="font-mono text-xs tracking-[0.16em] uppercase text-muted-dark mb-2">Navigation</div>
        <div>
          <a href="/author" className="hover:text-accent-dark transition-colors">Experimental Strategist</a> · 
          <a href="/notes" className="hover:text-accent-dark transition-colors ml-1">Observations</a>
        </div>
        <div className="mt-1">
          <a href="/" className="hover:text-accent-dark transition-colors">Experiments</a> · 
          <a href="/stats" className="hover:text-accent-dark transition-colors ml-1">Statistics</a>
        </div>
      </div>
      <div>
        <div className="font-mono text-xs tracking-[0.16em] uppercase text-muted-dark mb-2">Connect</div>
        <div>
          <a href="mailto:hello@deedslab.com" className="hover:text-accent-dark transition-colors">Research Contact</a>
        </div>
        <div className="mt-1">
          <a href="https://www.linkedin.com/in/ryandeeds/" target="_blank" rel="noopener noreferrer" className="hover:text-accent-dark transition-colors">LinkedIn</a> · 
          <a href="https://twitter.com/ryandeeds" target="_blank" rel="noopener noreferrer" className="hover:text-accent-dark transition-colors ml-1">Twitter</a>
        </div>
      </div>
      <div>
        <div className="font-mono text-xs tracking-[0.16em] uppercase text-muted-dark mb-2">Research Laboratory</div>
        <div className="max-w-md">
          An independent research laboratory exploring strategic questions through controlled experimentation.
          Findings and models are exploratory and do not represent institutional positions.
        </div>
      </div>
    </footer>
  )
}

